// extracted by mini-css-extract-plugin
export var avatarContainer = "_69-1";
export var largeAvatarContainer = "_69-2";
export var smallAvatarContainer = "_69-0";